import { render, staticRenderFns } from "./tab-panels.vue?vue&type=template&id=d2c4ec9e&"
import script from "./tab-panels.vue?vue&type=script&lang=js&"
export * from "./tab-panels.vue?vue&type=script&lang=js&"
import style0 from "./tab-panels.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tab-panels.vue"
export default component.exports